import React from "react";
import V2SpeechEditorLandingPage from "./V2SpeechEditorLandingPage";

const V2BeigeSpeechEditorLandingPage = () => (
    <V2SpeechEditorLandingPage appearance="beige" />
);

export default V2BeigeSpeechEditorLandingPage;
